<div class="chart-container">
    <p *ngIf="data?.length > 0 && !isMaterialChart" class="chart-title">{{chartTitle}}</p>
    <div [style.width]="isStacked ? '100%' : '690px'" [style.height]="chartHeight">
        <canvas #canvas>{{ chart }}</canvas>
    </div>
</div>

<div class="custom-table-list-row-main" *ngIf="isBarChartLoder">
    <div class="custom-col-width-100 text-danger d-flex justify-content-center">
        <app-common-icon [loadingIcon]="true"></app-common-icon>
    </div>
</div>

<div class="color-red chart-records" *ngIf="(!data || data.length === 0) && !isBarChartLoder">
    <p *ngIf="!showNoDataFound">The Storage is currently Empty</p>
    <p *ngIf="showNoDataFound">No Data Found !</p>
</div>